import { PARTNERS_IDS } from 'constants/partners';

import { FormStepId } from 'shared/config/formStepId';

const FillDataDescription = 'Заполните данные';

export const DefaultFormStepHeaders: Record<
  FormStepId,
  {
    title: string;
    description?: string;
  }
> = {
  [FormStepId.CreditPurposeInfo]: {
    title: 'Цель кредита',
    description: FillDataDescription,
  },
  [FormStepId.AdditionalInfo]: {
    title: 'Дополнительно',
    description: FillDataDescription,
  },
  [FormStepId.ContactsInfo]: {
    title: 'Контакты',
    description: FillDataDescription,
  },
  [FormStepId.PassportInfo]: {
    title: 'Паспортные данные',
    description: FillDataDescription,
  },
  [FormStepId.WorkplaceInfo]: {
    title: 'Работа',
    description: FillDataDescription,
  },
} as const;

export const CreditCardFormStepHeaders: Record<
  FormStepId,
  {
    title: string;
    description?: string;
  }
> = {
  ...DefaultFormStepHeaders,
  [FormStepId.CreditPurposeInfo]: {
    title: 'Кредитный лимит',
    description: FillDataDescription,
  },
} as const;

export const PartnerFormStepHeadersConfig: Record<
  number,
  Record<
    FormStepId,
    {
      title: string;
      description?: string;
    }
  >
> = {
  [PARTNERS_IDS.avito]: {
    [FormStepId.CreditPurposeInfo]: {
      title: 'Условия',
      description: FillDataDescription,
    },
    [FormStepId.AdditionalInfo]: {
      title: 'Дополнительно',
      description: FillDataDescription,
    },
    [FormStepId.ContactsInfo]: {
      title: 'Контактные данные',
      description: FillDataDescription,
    },
    [FormStepId.PassportInfo]: {
      title: 'Паспортные данные',
      description: FillDataDescription,
    },
    [FormStepId.WorkplaceInfo]: {
      title: 'Работа',
      description: FillDataDescription,
    },
  },
} as const;
